import { useNavigate } from "react-router";
import logo from "../img/logo.png";

function PremiumHeader() {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate("/");
    }
  return <div className="kl-header-premium">
      <div className="kl-logo-contab kl-logo-contab-premium">
        <img src={logo} alt="logo" />
      </div>
      <button onClick={handleBack}>
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.75098 4.25L14.2503 14.7493" stroke="white" strokeWidth="0.976744" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.74973 14.7493L14.249 4.25" stroke="white" strokeWidth="0.976744" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>;
}

export default PremiumHeader;
